export enum VisitMatchOptions {
    None = 0,
    OnLocation = 1,
    OnJourney = 2,
    OnJob = 4,
    OnDwell = 8
}
